import { createAction } from '@reduxjs/toolkit';
import { AssetsCache, CacheEntry, Loading, LoadingMode } from '../finder/model';
import { Asset, AssetsData } from '../../api';
import { ViewerData, ViewerShape } from './model';

export const assetsChanged = createAction<
  { data: AssetsData; hasNextPage: boolean; scrollHash: string },
  'al/viewer/assetsChanged'
>('al/viewer/assetsChanged');

export const cacheStored = createAction<
  { key: string; entry: CacheEntry<ViewerData> },
  'al/viewer/cacheStored'
>('al/viewer/cacheStored');

export const cacheHydrated = createAction<
  { cache: AssetsCache<ViewerData> },
  'al/viewer/cacheHydrated'
>('al/viewer/cacheHydrated');

// Запись локации больше не отражает сервер (в неё загрузили или из неё удалили файл).
// Выбрасываем и из памяти, и из localStorage — иначе следующий заход покажет снапшот
// до мутации, даже если сам force-запрос упадёт по сети.
export const cacheInvalidated = createAction<{ key: string }, 'al/viewer/cacheInvalidated'>(
  'al/viewer/cacheInvalidated',
);

export const thumbnailUpdated = createAction<{ assetId: Asset['id']; url: Asset['thumbnail_url'] }>(
  'al/viewer/thumbnailUpdated',
);

export const setLoading = createAction<{ loading: Loading }, 'al/viewer/setLoading'>(
  'al/viewer/setLoading',
);

export const loadAssetsRequested = createAction<
  { mode: LoadingMode; force?: boolean },
  'al/viewer/loadAssetsRequested'
>('al/viewer/loadAssetsRequested');

export const nextPageRequested = createAction<void, 'al/viewer/nextPageRequested'>(
  'al/viewer/nextPageRequested',
);

export const creativeChanged = createAction<
  { creative: ViewerShape['creative']; loadAssets?: boolean },
  'al/viewer/creativeChanged'
>('al/viewer/creativeChanged');
